import React, { Component, Fragment } from "react";
import "./developmentFabric.css";
import Button from "../../components/Buttons/Button";
import Loading from "../../components/Common/Loading";
import FileUpload from "../../components/FileUpload/FileUpload";
import leftArrowImage from "../../assets/images/left-arrow.png";
import Audit from "../../components/Common/audit";
import { confirmAlert } from "react-confirm-alert";

import {
  DevelopmentServices,
  CustomerServices,
  SystemServices,
  FileUploadService
} from "../../services";

//components
import {
  YarnDyed,
  Embroidery,
  Print,
  SolidGreige,
  FabricMainSection
} from "../../components/Fabric";
import SupplierSection from "../../components/SupplierSection/SupplierMain/SupplierSection";
import TrimSidebar from "../../components/TrimSidebar/index";
import Field from "../../components/Common/Field/Field";

//Assets
import download from "../../assets/images/download.png";
import printer from "../../assets/images/printer.png";
import PrintDevelopmentFabric from "../../components/PrintDevelopmentFabric";

//redux
import { connect } from "react-redux";
import getRights from "../../redux/action/rights";
import { bindActionCreators } from "redux";

class DevelopmentFabric extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,
    isLoading: false,
    duplicate: false,
    disableBtn: false,
    isLoadingSideBar: false,

    //options
    supplierInfo: [],
    bNumberInfo: [],
    embroideryInfo: {},
    fabricInfo: {
      ATTRIBUTE: [],
      PRINTBORDER: [],
      ORIGINATIONOFARTWORK: [],
      FILETRANSFER: [],
      PRINTDIRECTION: [],
      PRINTROUTE: [],
      PRINTINGMETHOD: [],
      BASICQUALITY: [],
      FABRICHSN: [],
      CLASSIFICATIONOFFABRIC: [],
      REQUIREMENT: [],
      FABRICBASE: [],
      COMPOSITION: [],
      DYESTUFF: [],
      WEAVE: [],
      FINISH: [],
      SHIPMENTTERM: [],
      SHIPMENTMODE: [],
      MACHINETYPE: [],
      EMBTECHNIQUE: [],
      PORTOFPICKUP: [],
      BUYERPRIMARYLIGHTSOURCE: [],
      WASH: [],
      NOOFCOLSONWEFT: [],
      DESIGNDESCRIPTION: [],
      NOOFCOLOURS: [],
      DESIGN: [],
      YARNDYED: {
        ASSIGNEDTO: [],
        TYPEOFLOOM: [],
        WEAVE: []
      }
    },
    customerList: [],
    buyerPrimarySourceInfo: [],
    actionedByOption: [],

    //values
    fabric: {
      HSN: null,
      fabricImage: "",
      fabricNumber: "",
      customer: null,
      qr: "",
      selectedType: "market",
      devRefNumber: "",
      priority: null,
      status: "pending",
      magnumETADate: null,
      requestDate: null,
      supplierETADate: null,
      //upload Images
      refImages: [],
      supplierName: null,
      gsm: "",
      width: "",
      classificationOfFabric: null,
      custDefNo: "",
      quality: null,
      colorWay: "",
      composition: null,
      orginationOfArtwork: null,
      requirement: null,
      magCadRefNo: "",
      refFabNo: "",
      customerDepartmentId: null,
      supplierRefNo: "",
      magnumStyleId: null,
      quantityReceived: "",
      attribute: null,
      buyerPrimarySource: null,
      dateRequiredAtMagnum: "",
      bNumber: null,
      fileTransfer: null,
      linktoBno: false,
      specialComments: "",
      yarnDyed: {
        designRepeatSize: "",
        actionedBy: null,
        wash: null,
        weave: null
      },
      embroidery: {
        scalloping: false,
        targetRateIncludingFigure: "",
        marker: false,
        gradingRequired: false,
        backing: false,
        backingDetails: "",
        // sourcing: null,
        actionedBy: null
      },
      print: {
        layerFile: false,
        artworkWithColSquare: false,
        fluroscentCols: false,
        rotaryRepeatSize: "",
        actionedBy: null
      },
      solidGreige: {
        actionedBy: null,
        typeOfLoom: null
      },
      supplierSection: {
        fullPackageData: [],
        jobWorkData: []
      },
      count: {
        warp: "",
        weft: ""
      },
      construction: {
        warp: "",
        weft: ""
      }
    },

    fabricPrint: {},
    //development
    development: null,

    //toggle
    toggle: {
      yarnDyed: false,
      embroidery: false,
      print: false,
      solidGreige: false,
      supplierSection: false
    },
    scroll: true,
    printLoading: false,
    forceUpdateCall: false,
    fabricId: "",
    rights: {
      supplier: {},
      yarnDyed: {},
      embroidery: {},
      print: {},
      solidGreige: {}
    }
  };

  componentWillMount() {
    let { action, _id, fabric } = this.state;
    if (this.props.location.state) {
      action = this.props.location.state.action,
        _id = this.props.location.state._id;
    }

    if (action === "" && _id === "") {
      const urlParams = new URLSearchParams(this.props.location.search)
      action = urlParams.get("action")
      _id = urlParams.get("_id")
      this.props.history.replace('/developmentFabric', {
        action, _id
      })
    }

    if (action != "add") {
      this.setState({
        scroll: false
      });
    }
    if (action === "edit") {
      this.setState({
        duplicate: true
      });
    }
    // window.addEventListener("afterprint", () =>  {alert("print")});

    this.setState(
      {
        action,
        _id,
        fabric,
        disabled: action === "view" ? true : false
      },
      () => {
        if (this.state._id !== "") {
          DevelopmentServices.getSpecificFabric(this.state._id)
            .then(response => {
              if (response.status === 200) {
                this.setState({ fabricId: response.text.data._id });
                let fabric = { ...this.state.fabric };
                let obj = { ...response.text.data };
                let toggle = { ...response.text.data.toggle };

                Object.keys(obj).forEach(function (key) {
                  if (key in fabric) {
                    fabric[key] = obj[key];
                  }
                });

                fabric.dateRequiredAtMagnum = new Date(
                  fabric.dateRequiredAtMagnum
                );
                this.setState({
                  fabric,
                  toggle,
                  isLoadingSideBar: true
                });
              }
              response.status === 401 && this.props.unauthorisedFunc();
            })
            .catch(error => {
              this.props.getalertMessage("error", error.toString());
            });
        } else {
          DevelopmentServices.generateQrCode()
            .then(response => {
              let fabric = { ...this.state.fabric };
              fabric.fabricNumber = response.data.fabricNumber;
              fabric.qr = response.data.qr;
              fabric.requestDate = new Date();
              (fabric.magnumETADate = new Date()),
                (fabric.supplierETADate = new Date()),
                this.setState({ fabric, isLoadingSideBar: true });
            })
            .catch(error => { });
        }
      }
    );
  }

  componentDidMount() {
    this.prefillData();
    if (this.state.action === "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww";
      });
    }

    let rights = {
      solidGreige: this.props.rights.solidGreige,
      embroidery: this.props.rights.embroidery,
      print: this.props.rights.print,
      yarnDyed: this.props.rights.yarnDyed,
      supplier: this.props.rights.supplier
    };

    this.setState({
      rights
    });
  }

  componentWillUnmount() {
    if (this.state.action === "add") {
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww";
      });
    }
  }

  prefillData = () => {
    //customer
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState({ customerList: response.text.data }, function () { });
        }
        response.status === 401 && this.props.unauthorisedFunc();
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString());
      })
      .finally(response => { });

    SystemServices.listCategoryContent("CURRENCY", "DELIVERYTERMS", "customers")
      .then(response => {
        if (response.message === "Operation Successful") {
          this.setState({ currency: response.data });
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString());
      });

    //get fabric section from system
    DevelopmentServices.prefillFabricDetails()
      .then(response => {
        let fabric = { ...this.state.fabric };

        fabric.yarnDyed.actionedBy =
          response.data.Fabric.YARNDYED.ASSIGNEDTO &&
            response.data.Fabric.YARNDYED.ASSIGNEDTO.length > 0
            ? response.data.Fabric.YARNDYED.ASSIGNEDTO[0].value
            : null;
        fabric.print.actionedBy =
          response.data.Fabric.PRINT.ASSIGN1EDTO &&
            response.data.Fabric.PRINT.ASSIGNEDTO.length > 0
            ? response.data.Fabric.PRINT.ASSIGNEDTO[0].value
            : null;
        fabric.embroidery.actionedBy =
          response.data.Fabric.EMBROIDERY.ASSIGNEDTO &&
            response.data.Fabric.EMBROIDERY.ASSIGNEDTO.length > 0
            ? response.data.Fabric.EMBROIDERY.ASSIGNEDTO[0].value
            : null;
        fabric.solidGreige.actionedBy =
          response.data.Fabric["GREIGE/DENIM"].ASSIGNEDTO &&
            response.data.Fabric["GREIGE/DENIM"].ASSIGNEDTO.length > 0
            ? response.data.Fabric["GREIGE/DENIM"].ASSIGNEDTO[0].value
            : null;

        this.setState({
          fabricInfo: response.data.Fabric,
          embroideryInfo: response.data.Embroidery,
          fabric
        });
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString());
      });

    //listBNumber
    DevelopmentServices.listBNumber()
      .then(response => {
        if (response.message === "List Displayed") {
          this.setState({ bNumberInfo: response.data }, function () { });
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString());
      });

    //buyer light primary source
    SystemServices.listCategoryContent(
      "PRIMARYLIGHTSOURCE",
      "CUSTOMER",
      "fabrics"
    )
      .then(response => {
        if (response.message === "Operation Successful") {
          this.setState({ buyerPrimarySourceInfo: response.data });
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString());
      });

    //generateQrCode
  };

  //fabric image func

  changeImg = e => {
    let file = e.target.files[0];
    if (file.size / 1024 > 1536) {
      this.props.getalertMessage("error", "Image cannot be more than 1.5 mb");
    } else {
      let moduleName = "fabric";
      this.setState({
        isLoading: true
      });
      FileUploadService.uploadFileForFabric(file, moduleName)
        .then(response => {
          if (response.status === 200) {
            let fabric = { ...this.state.fabric };
            fabric.fabricImage = response.text.data.url;
            this.setState({
              fabric,
              isLoading: false
            });
          } else if (response.status === 401) {
            this.props.unauthorisedFunc();
          } else {
            this.props.getalertMessage("error", response.text.message);
          }
        })
        .catch(error => {
          this.props.getalertMessage("error", error);
        });
    }
  };

  //submit Fabric to backend
  createFabric = e => {
    e.preventDefault();
    this.setState({ disableBtn: true });
    // data.development = { ...this.state.development }
    let fabric = { ...this.state.fabric };

    delete fabric.yarnDyed;
    delete fabric.embroidery;
    delete fabric.print;
    delete fabric.solidGreige;
    delete fabric.supplierSection;

    if (
      fabric.supplierName !== null &&
      typeof fabric.supplierName === "object"
    ) {
      fabric.supplierName = fabric.supplierName.value;
    }
    if (
      fabric.magnumStyleId !== null &&
      typeof fabric.magnumStyleId === "object"
    ) {
      fabric.magnumStyleId = fabric.magnumStyleId.value;
    }
    if (
      fabric.bNumber !== null &&
      typeof fabric.bNumber === "object"
    ) {
      fabric.bNumber = fabric.bNumber.value;
    }

    if (this.state._id) {
      fabric._id = this.state._id;
    }

    //delete fabric.bNumber;

    fabric.toggle = { ...this.state.toggle };

    if (fabric.fabricNumber == "") {
      this.props.getalertMessage("error", " No Fabric Number ");
      //  this.props.history.push('/developmentFabric',{ action : 'add', _id : "" })
      setTimeout(() => window.location.reload(true), 1000);
      this.setState({ disableBtn: false });
    } else {
      DevelopmentServices.createFabric(fabric)
        .then(response => {
          this.setState({ disableBtn: false })
          if (response.status === 200) {
            if (this.state._id) {
              this.props.getalertMessage("success", " Fabric Updated ");
            } else {
              this.props.getalertMessage("success", " Fabric Created ");
            }

            this.setState({
              _id: response.text.data._id,
              // fabric: response.text.data,
              duplicate: true
            });
          }
          response.status === 401 && this.props.unauthorisedFunc();
        })
        .catch(error => {
          this.setState({ disableBtn: false })
          this.msg.show("Try Again Later", {
            time: 2000,
            type: "info"
          });
        });
    }
  };

  getFabricData = (name, value) => {
    let fabric = { ...this.state.fabric };
  
    if (name == "customerDepartmentId") {
      this.state.customerList.map(data => {
        if (value == data.departmentId) {
          fabric[name] = data.departmentId;
          fabric.customer = data._id;
        }
      });
    } else {
      fabric[name] = value;
    }
    this.setState({
      fabric
    });
  };

  getRefImages = refImages => {
    let fabric = { ...this.state.fabric };
    fabric.refImages = refImages;
    this.setState({
      fabric
    });
  };

  getSubModuleData = (keyname, name, value) => {
    let fabric = { ...this.state.fabric };
    fabric[keyname][name] = value;
    this.setState({ fabric });
  };

  getSourcingData = sourcing => {
    let fabric = { ...this.state.fabric };
    fabric.embroidery.sourcing = sourcing;
    this.setState({ fabric });
  };

  //updating Value for count and construction
  updateCountConstruction = (e, keyname) => {
    let fabric = { ...this.state.fabric };
    fabric[keyname][e.target.name] = e.target.value;
    this.setState({
      fabric
    });
  };

  // Function to update fabric data in the parent component's state
  handleFabricDataUpdate = (updatedFabricData) => {
    //console.log("Updating fabric state:", updatedFabricData);
    this.setState((prevState) => ({
      fabric: {
        ...prevState.fabric,
        ...updatedFabricData, // Merge with existing fabric data
      },
    }));
  };

  //bnumber,style,supplier
  getSelectData = (name, value) => {
    let fabric = { ...this.state.fabric };
    fabric[name] = value;
    this.setState({ fabric });
  };

  //toggle
  toggleChange = (name, value) => {
    let toggle = { ...this.state.toggle };
    toggle[name] = value;
    this.setState({ toggle, scroll: true });
  };

  //supplierSection
  getSupplier = (data, name) => {
    let fabric = { ...this.state.fabric };
    fabric.supplierSection.supplierData =
      name === "fullPackageData" ? "fullPackage" : "jobWork";
    fabric.supplierSection[name] = data;
    this.setState({
      fabric
    });
  };

  getSupplierForDefault = supplierSection => {
    let fabric = { ...this.state.fabric };
    fabric.supplierSection = supplierSection;
    this.setState({
      fabric
    });
  };

  //development
  getDevRefNo = () => {
    if (this.state.fabric.devRefNumber === "") {
      DevelopmentServices.getDevRefNo().then(response => {
        if (response.status === 200) {
          let fabric = { ...this.state.fabric };
          fabric.devRefNumber = response.text.data;
          this.setState({ fabric });
        }
      });
    }
  };

  removeFabricImage = () => {
    let fabric = { ...this.state.fabric };
    fabric.fabricImage = "";
    this.setState({
      fabric
    });
  };

  openPrint = val => {
    let fabricPrint = JSON.parse(JSON.stringify(this.state.fabric));

    let fabricArray = [
      { keyName: "REQUIREMENT", keyValue: "requirement" },
      { keyName: "CLASSIFICATIONOFFABRIC", keyValue: "classificationOfFabric" },
      { keyName: "BASICQUALITY", keyValue: "quality" },
      { keyName: "COMPOSITION", keyValue: "composition" },
      { keyName: "BUYERPRIMARYLIGHTSOURCE", keyValue: "buyerPrimarySource" },
      { keyName: "ORIGINATIONOFARTWORK", keyValue: "orginationOfArtwork" },
      { keyName: "FILETRANSFER", keyValue: "fileTransfer" },
      { keyName: "ATTRIBUTE", keyValue: "attribute" }
    ];

    let yarnDyedArray = [
      { keyName: "TYPEOFLOOM", keyValue: "typeOfLoom" },
      { keyName: "DYESTUFF", keyValue: "dyeStuff" },
      { keyName: "WEAVE", keyValue: "weave" },
      { keyName: "FINISH", keyValue: "finish" },
      { keyName: "WASH", keyValue: "wash" },
      { keyName: "NOOFCOLSONWEFT", keyValue: "noOfColsWeft" }
    ];

    let embroideryArray = [
      { keyName: "EMBTECHNIQUE", keyValue: "embTechinique" },
      { keyName: "MACHINETYPE", keyValue: "machineType" },
      { keyName: "THREADQUALITY", keyValue: "threadQuality" },
      { keyName: "BASICQUALITY", keyValue: "fabricBase" },
      { keyName: "DESIGNDESCRIPTION", keyValue: "designDescription" }
    ];

    let printArray = [
      { keyName: "PRINTTYPE", keyValue: "printType" },
      { keyName: "PRINTDIRECTION", keyValue: "printDirection" },
      { keyName: "PRINTROUTE", keyValue: "printRoute" },
      { keyName: "NOOFCOLOURS", keyValue: "noOfColors" }
    ];

    let solidGreigeArray = [
      { keyName: "WEAVE", keyValue: "weave" },
      { keyName: "TYPEOFLOOM", keyValue: "typeOfLoom" },
      { keyName: "DESIGN", keyValue: "designDescription" }
    ];

    let fabricInfo = Object.assign({}, this.state.fabricInfo);
    fabricPrint.specialComments = this.state.fabric.specialComments;

    fabricArray.map(key => {
      fabricInfo[key.keyName].map(data => {
        if (data.value == fabricPrint[key.keyValue]) {
          fabricPrint[key.keyValue] = data.label;
        }
      });
    });

    yarnDyedArray.map(key => {
      if (key.keyValue == "weave" || key.keyValue == "typeOfLoom") {
        fabricInfo.YARNDYED[key.keyName].map(data => {
          if (data.value == fabricPrint.yarnDyed[key.keyValue]) {
            fabricPrint.yarnDyed[key.keyValue] = data.label;
          }
        });
      } else {
        fabricInfo[key.keyName].map(data => {
          if (data.value == fabricPrint.yarnDyed[key.keyValue]) {
            fabricPrint.yarnDyed[key.keyValue] = data.label;
          }
        });
      }
    });

    embroideryArray.map(key => {
      fabricInfo[key.keyName].map(data => {
        if (data.value == fabricPrint.embroidery[key.keyValue]) {
          fabricPrint.embroidery[key.keyValue] = data.label;
        }
      });
    });

    printArray.map(key => {
      fabricInfo[key.keyName].map(data => {
        if (data.value == fabricPrint.print[key.keyValue]) {
          fabricPrint.print[key.keyValue] = data.label;
        }
      });
    });

    solidGreigeArray.map(key => {
      if (key.keyValue == "designDescription") {
        fabricInfo[key.keyName].map(data => {
          if (data.value == fabricPrint.solidGreige[key.keyValue]) {
            fabricPrint.solidGreige[key.keyValue] = data.label;
          }
        });
      } else {
        fabricInfo["GREIGE/DENIM"][key.keyName].map(data => {
          if (data.value == fabricPrint.solidGreige[key.keyValue]) {
            fabricPrint.solidGreige[key.keyValue] = data.label;
          }
        });
      }
    });

    if (typeof fabricPrint.supplierName == "string") {
      fabricInfo.SUPPLIERNAME.map(data => {
        if (data.value == fabricPrint.supplierName) {
          fabricPrint.supplierName = data;
        }
      });
    }

    let fabricModule = [
      { keyName: "GREIGE/DENIM", keyValue: "solidGreige" },
      { keyName: "YARNDYED", keyValue: "yarnDyed" },
      { keyName: "EMBROIDERY", keyValue: "embroidery" },
      { keyName: "PRINT", keyValue: "print" }
    ];
    fabricModule.map(modulee => {
      fabricInfo[modulee.keyName].ASSIGNEDTO.map(data => {
        if (data.value == fabricPrint[modulee.keyValue].actionedBy) {
          fabricPrint[modulee.keyValue].actionedBy = data.label;
        }
      });
    });
    this.state.customerList.map(data => {
      if (data.departmentId == fabricPrint.customerDepartmentId) {
        fabricPrint.customer = `${data.customerName}-${data.departmentName}`;
      }
    });

    const toggle = { ...this.state.toggle };

    Object.keys(toggle).forEach(function (keyName) {
      if (!toggle[keyName]) {
        fabricPrint[keyName] = null;
      }
    });

    fabricPrint.development = false;
    fabricPrint.magnumETADate = this.state.fabric.magnumETADate;
    fabricPrint.requestDate = this.state.fabric.requestDate;

    var fabricDevRadio = document.getElementsByName("fabricDevRadio");

    fabricDevRadio.forEach(dev => {
      if (dev.checked && dev.value == "development") {
        fabricPrint.development = true;
      }
    });
    this.setState(
      {
        fabricPrint,
        printLoading: true
      },
      () => {
        if (toggle.supplierSection) {
          let fullPackage, jobWork;
          let { supplierSection } = { ...this.state.fabric };

          supplierSection.fullPackageData &&
            supplierSection.fullPackageData.find((x, i) => {
              if (x.default) {
                fullPackage = `fullPack${i}`;
              }
            });
          supplierSection.jobWorkData &&
            supplierSection.jobWorkData.find((x, i) => {
              if (x.default) {
                jobWork = `jobWrk${i}`;
              }
            });
          var divToPrint = document.getElementById(val);
          var newWin = window.open("", "mywindow");
          newWin.document.write(divToPrint.outerHTML);
          newWin.document.close();
          newWin.onload = () => {
          newWin.focus()
          newWin.print()
          newWin.close()
        }
        } else {
          var divToPrint = document.getElementById(val);
          var newWin = window.open("", "mywindow");
          newWin.document.write(divToPrint.outerHTML);
           newWin.document.close();
          newWin.onload = () => {
          newWin.focus()
          newWin.print()
          newWin.close()
        }
          // newWin.focus();
          // newWin.print();
          // // this.onPrintFinished(newWin.print())
          // newWin.close();
        }
      }
    );
  };

  onPrintFinished = () => {
    if (this.state.action !== "view") {
      this.props.history.push("/developmentFabric", {
        action: "edit",
        _id: this.state._id
      });
    }
    // setTimeout(() => document.location.reload(true), 100)
  };

  //selectedRadio
  updateSelectedRadio = value => {
    let fabric = { ...this.state.fabric };
    fabric.selectedType = value;
    if (value == "market") {
      fabric.devRefNumber = "";
    }
    this.setState({
      fabric
    });
  };

  //fullpackage

  getFullPackage = fullPackageData => {
    let fabric = { ...this.state.fabric };
    fullPackageData.map((data, index) => {
      data.purposeLabel =
        data.purpose !== null &&
        this.state.fabricInfo.PURPOSE &&
        this.state.fabricInfo.PURPOSE.map((purpose, i) => {
          if (purpose.value === data.purpose) {
            return purpose.label;
          }
        }).filter(Boolean)[0];

      data.SupplierNameLabel =
        data.supplierName !== null &&
        this.state.fabricInfo.SUPPLIERNAME &&
        this.state.fabricInfo.SUPPLIERNAME.map((SUPPLIERNAME, i) => {
          if (SUPPLIERNAME.value === data.supplierName) {
            return SUPPLIERNAME.label;
          }
        }).filter(Boolean)[0];
    });
    fabric.supplierSection.fullPackageData = fullPackageData;
    this.setState({
      fabric
    });
  };

  getJobwork = jobWorkData => {
    let fabric = { ...this.state.fabric };

    jobWorkData.map((data, index) => {
      data.purposeLabel =
        data.purpose !== null &&
        this.state.fabricInfo.PURPOSE &&
        this.state.fabricInfo.PURPOSE.map((purpose, i) => {
          if (purpose.value === data.purpose) {
            return purpose.label;
          }
        }).filter(Boolean)[0];

      data.rowData.map((dat, i) => {
        dat.SupplierNameLabel =
          dat.supplierName !== null &&
          this.state.fabricInfo.SUPPLIERNAME &&
          this.state.fabricInfo.SUPPLIERNAME.map((SUPPLIERNAME, i) => {
            if (SUPPLIERNAME.value === dat.supplierName) {
              return SUPPLIERNAME.label;
            }
          }).filter(Boolean)[0];
      });
    });
    fabric.supplierSection.jobWorkData = jobWorkData;
    this.setState({
      fabric
    });
  };

  confirmDuplicate = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className=" p-5 text-center">
            <h3>Do you want to create a duplicate Development Fabric sheet?</h3>
            {/* <p>
              If yes, Kindly don't forget to change/choose the new Source of
              Request and the Sample Type.{" "}
              <strong>
                (marked with{" "}
                <span className="text-danger madatory-asterisk">*</span>)
              </strong>
            </p> */}
            {/* <p>Are you sure you would like to Duplicate?</p> */}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={onClose}
            >
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={() => {
                this.createDuplicate();
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      closeOnClickOutside: true
    });
  };
  createDuplicate = () => {
    DevelopmentServices.generateQrCode()
      .then(response => {
        let fabric = { ...this.state.fabric };
        fabric.fabricNumber = response.data.fabricNumber;
        fabric.qr = response.data.qr;
        fabric.requestDate = new Date();
        (fabric.magnumETADate = new Date()),
          (fabric.supplierETADate = new Date()),
          this.setState({
            fabric,
            isLoadingSideBar: true,
            duplicate: false,
            action: "add",
            _id: ""
          });
        this.props.getalertMessage("success", "Duplicate Success!", 5000);
      })
      .catch(error => {
        this.props.getalertMessage("error");
      });

    // SampleServices.getSampleQr()
    //   .then(response => {
    //     if (response.status === 200) {
    //       let sampleRequest = { ...this.state.sampleRequest }
    //       sampleRequest.qr = response.text.data.qr
    //       sampleRequest.requestNumber = response.text.data.requestNumber
    //       sampleRequest.typeOfRequest = ""
    //       sampleRequest.sampleType = null
    //       this.setState({
    //         sampleRequest,
    //         action: "add",
    //         _id: ""
    //         // isLoading: false
    //       })
    //       this.props.getalertMessage(
    //         "success",
    //         "Duplicate Success! Please select Source of Request and Sample Type",
    //         5000
    //       )
    //     }
    //     response.status === 401 && this.props.unauthorisedFunc()
    //   })
    //   .catch(err => {
    //     this.props.getalertMessage("error")
    //   })
  };

  // rendering func
  render() {
    let { fabric, isLoadingSideBar, toggle, rights } = this.state;
  
    // console.log(rights, "RIGHTS")
    // console.log(this.props, "PROPS")
    return (
      <Fragment>
        <div className="right-section remove-scroll-for-right">
          <div className="row nopadding bg-white">
            <div className="col-md-12 no-padding">
              <form id="fabricCreation" className="w-100">
                <div className="col-md-12 nopadding">
                  {/* <Button
                        history={this.props.history}
                        buttonType="back"
                      /> */}
                  {/* Left Section start */}
                  {this.state.isLoading && <Loading />}
                  {isLoadingSideBar && (
                    <TrimSidebar
                      moduleName={"fabric"}
                      number={this.state.fabric.fabricNumber}
                      qr={this.state.fabric.qr}
                      image={this.state.fabric.fabricImage}
                      HSN={this.state.fabric.HSN}
                      handleImageUpload={this.changeImg}
                      onInputChange={this.getHsnOptions}
                      onChange={this.onChange}
                      hsnOptions={this.state.fabricInfo.FABRICHSN}
                      disabled={this.state.action === "view" ? true : false}
                      getFabricData={this.getFabricData}
                      removeFabricImage={this.removeFabricImage}
                    />
                  )}

                  {/* Right section Start */}
                  <div className="right-content-section overflow-scroll ">
                    <div class="col-md-12 px-0 py-2 position-top-stick">
                      <div className="col-md-4 nopadding text-left">
                        <span
                          className="p-2 cursor-hover"
                          onClick={() => {
                            const { route } = this.props.history.location.state;
                            route !== undefined
                              ? this.props.history.push(`/${route}`, {
                                [`${route.toLowerCase()}`]: {
                                  ...this.props.history.location.state[
                                  `${route.toLowerCase()}`
                                  ]
                                }
                              })
                              : this.props.history.goBack();
                          }}
                        >
                          <img width={"20px"} src={leftArrowImage} />
                        </span>
                      </div>
                      <div className="col-md-4 nopadding text-center">
                        <h6>{"Fabric Development"}</h6>
                      </div>
                      <div className="col-md-4 text-right">
                        <Audit
                          _id={this.state._id}
                          locationInfo={this.props.location}
                        />
                        <span
                          className="btn-green-icon mr-3"
                          onClick={e =>
                            this.openPrint("printDevelopmentFabric")
                          }
                        >
                          <img src={printer} />
                        </span>
                        <span className="btn-green-icon">
                          <img src={download} />
                        </span>
                      </div>
                    </div>
                    {/* Fabric main section  */}
                    <FabricMainSection
                      fabricInfo={this.state.fabricInfo}
                      fabric={fabric}
                      getFabricData={this.getFabricData}
                      updateCountConstruction={this.updateCountConstruction}
                      updateFabricData={this.handleFabricDataUpdate}
                      updateSelectedRadio={this.updateSelectedRadio}
                      getSelectData={this.getSelectData}
                      getDevRefNo={this.getDevRefNo}
                      disabled={
                        this.state.action === "view"
                          ? true
                          : this.state.disabled
                        // this.props.rights.fabric.web.view
                        //   ? this.props.rights.fabric.web.create ||
                        //     this.props.rights.fabric.web.edit
                        //     ? false
                        //     : true
                        //   : this.state.disabled
                      }
                      getalertMessage={this.props.getalertMessage}
                      unauthorisedFunc={this.props.unauthorisedFunc}
                    />
                    {/* Image Upload section Start */}
                    <div class="col-md-12 no-padding px-5 mt-2">
                      <FileUpload
                        Heading="Upload Images"
                        moduleName={"fabric"}
                        getRefImages={this.getRefImages}
                        disabled={this.state.disabled}
                        uploadedDocs={
                          (this.state.action === "edit" ||
                            this.state.action === "add") &&
                            isLoadingSideBar
                            ? fabric.refImages
                            : null
                        }
                        imageTypeOption={
                          this.state.fabricInfo &&
                            this.state.fabricInfo.IMAGETYPE
                            ? this.state.fabricInfo.IMAGETYPE
                            : []
                        }
                      />
                    </div>

                    <div className="col-md-12 text-center profile-btn">
                      {this.state.action !== "view" &&
                        this.state.duplicate === true && (
                          <Button
                            buttonType="save"
                            buttonName="Create Duplicae"
                            onClick={this.confirmDuplicate}
                          />
                        )}
                      {this.state.action != "view" && (
                        <Button
                          buttonType="save"
                          buttonName="save"
                          disabled={this.state.disableBtn}
                          onClick={this.createFabric}
                        />
                      )}
                      <Button
                        history={this.props.history}
                        buttonType="cancel"
                        buttonName="Cancel"
                      />
                    </div>

                    {/* SUb module section */}
                    <div className="col-md-12 my-5 px-5">
                      <ul className="nav-locator mt-0 d-flex flex-row justify-content-center align-items-center">
                        <li>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="yarnDyed"
                            className={toggle.yarnDyed ? "" : "print-hidden"}
                            value={toggle.yarnDyed}
                            label="Yarn Dyed"
                            onChange={this.toggleChange}
                            disabled={this.state.disabled}
                          />
                        </li>
                        <li>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="embroidery"
                            label="Embroidery"
                            className={toggle.embroidery ? "" : "print-hidden"}
                            value={toggle.embroidery}
                            onChange={this.toggleChange}
                            disabled={this.state.disabled}
                          />
                        </li>
                        <li>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="print"
                            label="Print"
                            className={toggle.print ? "" : "print-hidden"}
                            value={toggle.print}
                            onChange={this.toggleChange}
                            disabled={this.state.disabled}
                          />
                        </li>
                        <li>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="solidGreige"
                            value={toggle.solidGreige}
                            label="Greige/Denim"
                            className={toggle.solidGreige ? "" : "print-hidden"}
                            onChange={this.toggleChange}
                            disabled={this.state.disabled}
                          />
                        </li>
                        <li>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="supplierSection"
                            label="Supplier"
                            className={
                              toggle.supplierSection ? "" : "print-hidden"
                            }
                            value={toggle.supplierSection}
                            onChange={this.toggleChange}
                            disabled={this.state.disabled}
                          />
                        </li>
                      </ul>
                    </div>

                    {/* Yarn dyed section start */}
                    {toggle.yarnDyed && this.props.rights.yarnDyed.web.view && (
                      <YarnDyed
                        fabricInfo={this.state.fabricInfo}
                        yarnDyed={fabric.yarnDyed}
                        action={this.state.action}
                        toggle={this.state.toggle}
                        _id={this.state._id}
                        getYarnDyed={this.getSubModuleData}
                        disabled={
                          this.state.action !== "view"
                            ? this.props.rights.yarnDyed.web.create ||
                              this.props.rights.yarnDyed.web.edit
                              ? false
                              : true
                            : !this.state.disabled
                        }
                        unauthorisedFunc={this.props.unauthorisedFunc}
                        getalertMessage={this.props.getalertMessage}
                        history={this.props.history}
                        scroll={this.state.scroll}
                      />
                    )}
                    {/* Embroidery section start */}
                    {toggle.embroidery && this.props.rights.embroidery.web.view && (
                      <Embroidery
                        fabricInfo={this.state.fabricInfo}
                        action={this.state.action}
                        embroideryInfo={this.state.embroideryInfo}
                        embroidery={fabric.embroidery}
                        toggle={this.state.toggle}
                        _id={this.state._id}
                        getEmbroidery={this.getSubModuleData}
                        getSourcingData={this.getSourcingData}
                        disabled={
                          this.state.action !== "view"
                            ? this.props.rights.embroidery.web.create ||
                              this.props.rights.embroidery.web.edit
                              ? false
                              : true
                            : !this.state.disabled
                        }
                        unauthorisedFunc={this.props.unauthorisedFunc}
                        getalertMessage={this.props.getalertMessage}
                        history={this.props.history}
                        scroll={this.state.scroll}
                      />
                    )}

                    {/* Print section start */}
                    {toggle.print && this.props.rights.print.web.view && (
                      <Print
                        fabricInfo={this.state.fabricInfo}
                        action={this.state.action}
                        print={fabric.print}
                        toggle={this.state.toggle}
                        _id={this.state._id}
                        getPrint={this.getSubModuleData}
                        disabled={
                          this.state.action !== "view"
                            ? this.props.rights.print.web.create ||
                              this.props.rights.print.web.edit
                              ? false
                              : true
                            : !this.state.disabled
                        }
                        unauthorisedFunc={this.props.unauthorisedFunc}
                        getalertMessage={this.props.getalertMessage}
                        history={this.props.history}
                        scroll={this.state.scroll}
                      />
                    )}

                    {/* Solid greige section start */}
                    {toggle.solidGreige && this.props.rights.solidGreige.web.view && (
                      <SolidGreige
                        forceUpdateCall={this.state.forceUpdateCall}
                        solidGreige={fabric.solidGreige}
                        action={this.state.action}
                        toggle={this.state.toggle}
                        _id={this.state._id}
                        getSolidGreige={this.getSubModuleData}
                        fabricInfo={this.state.fabricInfo}
                        disabled={
                          this.state.action !== "view"
                            ? this.props.rights.solidGreige.web.create ||
                              this.props.rights.solidGreige.web.edit
                              ? false
                              : true
                            : !this.state.disabled
                        }
                        unauthorisedFunc={this.props.unauthorisedFunc}
                        getalertMessage={this.props.getalertMessage}
                        history={this.props.history}
                        scroll={this.state.scroll}
                      />
                    )}

                    {/** supplier section  start*/}
                    {toggle.supplierSection && this.props.rights.supplier.web.view && (
                      <SupplierSection
                        moduleName={"Fabric"}
                        action={this.state.action}
                        scrollSupplier={this.state.scroll}
                        // scrollSupplier = {toggle.supplierSection}
                        getFullPackage={this.getFullPackage}
                        getJobWork={this.getJobwork}
                        suppliersOption={this.state.supplierInfo}
                        fullPackageData={fabric.supplierSection.fullPackageData}
                        jobWorkData={fabric.supplierSection.jobWorkData}
                        toggle={this.state.toggle}
                        _id={this.state._id}
                        disabled={
                          this.state.action !== "view"
                            ? this.props.rights.supplier.web.create ||
                              this.props.rights.supplier.web.edit
                              ? false
                              : true
                            : !this.state.disabled
                        }
                        unauthorisedFunc={this.props.unauthorisedFunc}
                        getalertMessage={this.props.getalertMessage}
                        fabricInfo={this.state.fabricInfo}
                        history={this.props.history}
                        getSupplierForDefault={this.getSupplierForDefault}
                      />
                    )}

                    <div id="printDevelopmentFabric" className="d-none">
                      {this.state.printLoading && (
                        <PrintDevelopmentFabric
                          fabric={this.state.fabricPrint}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

// export default ;

const mapStateToProps = state => {
  return {
    rights: state.main.rights.fabric,
    selectedRight: state.rights.rightsInfo
  };
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getRights: getRights
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DevelopmentFabric);


// WEBPACK FOOTER //
// ./src/pages/developmentFabric/page.js